'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { List } from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import debounce from 'transmute/debounce';
import { findDOMNode } from 'react-dom';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIFlex from 'UIComponents/layout/UIFlex';
import ComponentWithWindowListeners from 'UIComponents/mixins/ComponentWithWindowListeners';
import CompanyLogo from 'MeetingsLib/components/decorative/CompanyLogo';
import CompactBookingPage from 'MeetingsLib/components/page/CompactBookingPage';
import FullSizeBookingPage from 'MeetingsLib/components/page/FullSizeBookingPage';
import RescheduleHeader from 'MeetingsLib/components/page/RescheduleHeader';
import TroubleshootModeToggle from 'MeetingsLib/components/header/TroubleshootModeToggle';
import { canSubmitInitialPropertyForm as canSubmitInitialPropertyFormSelector } from 'MeetingsLib/selectors/AutoSubmitSelector';
import { shouldShowEmailForm as shouldShowEmailFormSelector, getLegalConsentEnabled, getRecaptchaEnabled } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getLegalConsentResponses } from 'MeetingsLib/selectors/LegalConsentFormSelectors';
import { getIsFetchingPublicAvailability } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { canTroubleshootSelector } from 'MeetingsLib/selectors/TroubleshootingSelectors';
import * as BookActions from 'MeetingsLib/redux/actions/BookActions';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import * as UIActions from 'MeetingsLib/redux/actions/UIActions';
import * as TroubleshootActions from 'MeetingsLib/redux/actions/TroubleshootActions';
import UserProfile from 'MeetingsBase/models/UserProfile';
import Branding from 'MeetingsBase/models/Branding';
import UserMessage from 'MeetingsLib/models/UserMessage';
import BookingLifecycle from 'MeetingsLib/models/BookingLifecycle';
import FormState from 'MeetingsLib/models/FormState';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
var COMPACT_BREAKPOINT = 632;
var Booking = createReactClass({
  displayName: "Booking",
  mixins: [ComponentWithWindowListeners],
  propTypes: {
    // passed
    avatar: PropTypes.string,
    companyAvatar: PropTypes.string,
    branding: PropTypes.instanceOf(Branding).isRequired,
    displayAvatarOption: PropTypes.string,
    welcomeScreenInfo: PropTypes.instanceOf(WelcomeScreenInfo).isRequired,
    headline: PropTypes.string,
    hideLogo: PropTypes.bool,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    submittingMeeting: PropTypes.bool,
    DatePickerMarker: PropTypes.func.isRequired,
    TimePickerMarker: PropTypes.func.isRequired,
    EmailFormMarker: PropTypes.func.isRequired,
    // loaded
    bookingLifecycle: PropTypes.instanceOf(BookingLifecycle).isRequired,
    emailFormState: PropTypes.string,
    formState: PropTypes.instanceOf(FormState),
    recaptchaEnabled: PropTypes.bool.isRequired,
    legalConsentEnabled: PropTypes.bool,
    legalConsentResponses: PropTypes.instanceOf(List),
    canSubmitInitialPropertyForm: PropTypes.bool,
    embedded: PropTypes.bool.isRequired,
    forceMobile: PropTypes.bool,
    isFetchingPublicAvailability: PropTypes.bool.isRequired,
    isRescheduling: PropTypes.bool,
    canTroubleshoot: PropTypes.bool,
    troubleshooting: PropTypes.bool.isRequired,
    toggleTroubleshootMode: PropTypes.func.isRequired,
    fetchTroubleshootTimes: PropTypes.func.isRequired,
    shouldShowEmailForm: PropTypes.bool,
    userMessage: PropTypes.instanceOf(UserMessage)
  },
  getInitialState: function getInitialState() {
    return {
      compact: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var forceMobile = this.props.forceMobile;

    if (forceMobile || window.innerWidth < COMPACT_BREAKPOINT) {
      this.setState({
        compact: true
      });
    }
  },
  componentDidMount: function componentDidMount() {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    this.handleResizeIFrame();
  },
  getContainerNode: function getContainerNode(element) {
    if (element) {
      this.containerNode = findDOMNode(element);
    }
  },
  getWindowListeners: function getWindowListeners() {
    var embedded = this.props.embedded;
    var resizeHandler = embedded ? this.handleResize : debounce(100, this.handleResize);
    return {
      resize: resizeHandler
    };
  },
  handleResize: function handleResize(e) {
    var forceMobile = this.props.forceMobile;
    var compact = this.state.compact;

    if (forceMobile) {
      return this.handleResizeIFrame();
    }

    if (e.target.innerWidth < COMPACT_BREAKPOINT && !compact) {
      this.setState({
        compact: true
      });
    } else if (e.target.innerWidth >= COMPACT_BREAKPOINT && compact) {
      this.setState({
        compact: false
      });
    }

    return this.handleResizeIFrame();
  },
  getNextIFrameHeight: function getNextIFrameHeight() {
    return this.containerNode.getBoundingClientRect().height + 25;
  },
  handleResizeIFrame: function handleResizeIFrame() {
    if (this.props.embedded && this.containerNode) {
      var height = this.getNextIFrameHeight();
      parent.postMessage({
        height: height
      }, '*');
    }
  },
  getBookingComponent: function getBookingComponent() {
    return this.state.compact ? CompactBookingPage : FullSizeBookingPage;
  },
  renderBookInterface: function renderBookInterface() {
    var _this$props = this.props,
        avatar = _this$props.avatar,
        companyAvatar = _this$props.companyAvatar,
        bookingLifecycle = _this$props.bookingLifecycle,
        displayAvatarOption = _this$props.displayAvatarOption,
        emailFormState = _this$props.emailFormState,
        formState = _this$props.formState,
        recaptchaEnabled = _this$props.recaptchaEnabled,
        legalConsentEnabled = _this$props.legalConsentEnabled,
        legalConsentResponses = _this$props.legalConsentResponses,
        branding = _this$props.branding,
        canSubmitInitialPropertyForm = _this$props.canSubmitInitialPropertyForm,
        shouldShowEmailForm = _this$props.shouldShowEmailForm,
        canTroubleshoot = _this$props.canTroubleshoot,
        embedded = _this$props.embedded,
        headline = _this$props.headline,
        isFetchingPublicAvailability = _this$props.isFetchingPublicAvailability,
        profile = _this$props.profile,
        welcomeScreenInfo = _this$props.welcomeScreenInfo,
        submittingMeeting = _this$props.submittingMeeting,
        DatePickerMarker = _this$props.DatePickerMarker,
        TimePickerMarker = _this$props.TimePickerMarker,
        EmailFormMarker = _this$props.EmailFormMarker;
    var Component = this.getBookingComponent();
    return /*#__PURE__*/_jsx(Component, {
      avatar: avatar,
      companyAvatar: companyAvatar,
      displayAvatarOption: displayAvatarOption,
      bookingLifecycle: bookingLifecycle,
      emailFormState: emailFormState,
      formState: formState,
      recaptchaEnabled: recaptchaEnabled,
      legalConsentEnabled: legalConsentEnabled,
      legalConsentResponses: legalConsentResponses,
      branding: branding,
      canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
      canTroubleshoot: canTroubleshoot,
      embedded: embedded,
      headline: headline,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      profile: profile,
      welcomeScreenInfo: welcomeScreenInfo,
      shouldShowEmailForm: shouldShowEmailForm,
      submittingMeeting: submittingMeeting,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderPotentialAlert: function renderPotentialAlert() {
    var userMessage = this.props.userMessage;

    if (userMessage) {
      return /*#__PURE__*/_jsx("div", {
        className: "m-all-6",
        children: /*#__PURE__*/_jsx(UIAlert, {
          type: userMessage.type,
          children: userMessage.content
        })
      });
    }

    return null;
  },
  renderCompanyLogo: function renderCompanyLogo() {
    var _this$props2 = this.props,
        branding = _this$props2.branding,
        embedded = _this$props2.embedded,
        hideLogo = _this$props2.hideLogo;

    if (embedded || hideLogo) {
      return null;
    }

    return /*#__PURE__*/_jsx(CompanyLogo, {
      compact: this.state.compact,
      branding: branding
    });
  },
  renderRescheduleHeader: function renderRescheduleHeader() {
    var isRescheduling = this.props.isRescheduling;
    return isRescheduling && /*#__PURE__*/_jsx(RescheduleHeader, {});
  },
  renderTroubleshootModeToggle: function renderTroubleshootModeToggle() {
    var _this$props3 = this.props,
        canTroubleshoot = _this$props3.canTroubleshoot,
        troubleshooting = _this$props3.troubleshooting,
        toggleTroubleshootMode = _this$props3.toggleTroubleshootMode,
        fetchTroubleshootTimes = _this$props3.fetchTroubleshootTimes,
        isRescheduling = _this$props3.isRescheduling;

    if (isRescheduling) {
      return null;
    }

    if (!canTroubleshoot) {
      return null;
    }

    return !this.state.compact && /*#__PURE__*/_jsx(TroubleshootModeToggle, {
      canTroubleshoot: canTroubleshoot,
      troubleshooting: troubleshooting,
      toggleTroubleshootMode: toggleTroubleshootMode,
      fetchTroubleshootTimes: fetchTroubleshootTimes
    });
  },
  render: function render() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "center",
      className: "meetings-page",
      ref: this.getContainerNode,
      children: [this.renderCompanyLogo(), this.renderRescheduleHeader(), this.renderTroubleshootModeToggle(), this.renderPotentialAlert(), this.renderBookInterface()]
    });
  }
});
export default connect(function (state) {
  return {
    canSubmitInitialPropertyForm: canSubmitInitialPropertyFormSelector(state),
    canTroubleshoot: canTroubleshootSelector(state),
    embedded: state.embedded,
    eventDetails: state.eventDetails,
    forceMobile: state.forceMobile,
    isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
    isSalesStarter: state.isSalesStarter,
    shouldShowEmailForm: shouldShowEmailFormSelector(state),
    emailFormState: state.emailFormState,
    troubleshooting: state.troubleshooting.active,
    userMessage: state.userMessage,
    bookingLifecycle: state.bookingLifecycle,
    formState: state.formState,
    legalConsentEnabled: getLegalConsentEnabled(state),
    recaptchaEnabled: getRecaptchaEnabled(state),
    legalConsentResponses: getLegalConsentResponses(state),
    isRescheduling: state.isRescheduling
  };
}, Object.assign({}, BookActions, {}, FormActions, {}, UIActions, {}, TroubleshootActions))(Booking);